import type { InboxEntry } from '@this+that/models';

const MAX_INSERT_VERSION = 1;

export const isFreshInsert = (entry: InboxEntry) =>
  (entry.version ?? 0) <= MAX_INSERT_VERSION;

export const isOpen = (entry: InboxEntry) =>
  !entry.resolvedAt && !entry.deletedAt;
